import { AppState, Auth0Context, Auth0ContextInterface, Auth0Provider, initialContext } from '@auth0/auth0-react';
import { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { config } from 'config/auth';
import { runtimeConfig } from 'config/runtimeConfig';

const environment = runtimeConfig.ENV_NAME;

interface Auth0ProviderWithNavigateProps {
  children: ReactNode;
}

export function Auth0ProviderWithNavigate({ children }: Auth0ProviderWithNavigateProps) {
  const navigate = useNavigate();
  const [e2eCookie] = useState(Cookies.get('e2eToken'));
  const [isE2E] = useState(!!e2eCookie && environment !== 'prod');

  const createTestContext = () =>
    ({
      ...initialContext,
      isAuthenticated: true,
      isLoading: false,
      getAccessTokenSilently: () =>
        new Promise(resolve => {
          resolve(e2eCookie ?? '');
        }),
    }) as Auth0ContextInterface;

  const authConfig = {
    AUTH0_DOMAIN: config.AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: config.AUTH0_CLIENT_ID,
    AUTH0_REDIRECT_URL: config.AUTH0_REDIRECT_URL,
    AUTH0_AUDIENCE: config.AUTH0_AUDIENCE,
  };

  const { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_REDIRECT_URL, AUTH0_AUDIENCE } = authConfig;

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo ?? window.location.pathname);
  };

  return isE2E ? (
    <Auth0Context.Provider value={createTestContext()}>{children}</Auth0Context.Provider>
  ) : (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: AUTH0_AUDIENCE,
        redirect_uri: AUTH0_REDIRECT_URL,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}
